export default __webpack_public_path__ + "static/media/delete.02ee14c3.svg";